import { Component } from '@angular/core';
import { MatomoInjector } from 'ngx-matomo';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Adventskalender';

  constructor(private matomoInjector: MatomoInjector
  ) {
    this.matomoInjector.init('https://stats.kg-grw.de/', 1);
  }

  ngOnInit()  {
    let cc = window as any;
    cc.cookieconsent.initialise({
      palette: {
        popup: {
          background: "#fff3cd"
        },
        button: {
          background: "transparent",
          border: "1px",
          text: "#212529"
        }
      },
      theme: "classic",
      content: {
        message: 'Diese Anwendung benutzt Cookies, um den vollen Funktionsumfang bereitstellen zu können. Zur Optimierung werden Tracking&#8209;Cookies gesetzt, die manuell abgewählt werden können.',
        dismiss: 'Okay',
        link: 'Mehr erfahren',
        href: "https://www.kirche-grossrueckerswalde.de/index.php/datenschutz " 
      }
    });
  }
}
